import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=63ae8d00&scoped=true"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=63ae8d00&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae8d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ae8d00')) {
      api.createRecord('63ae8d00', component.options)
    } else {
      api.reload('63ae8d00', component.options)
    }
    module.hot.accept("./subscribe.vue?vue&type=template&id=63ae8d00&scoped=true", function () {
      api.rerender('63ae8d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/venue/subscribe.vue"
export default component.exports